<div class="container">
  <div class="text-center mt-4">
    <img id="logo" class="img-fluid" src="images/akvarium_logo.svg">
  </div>
  <div *ngIf="!paymentSucceeded" class="mt-5">
    <ngx-stripe-elements *ngIf="stripeElementsOptions"
      [stripe]="stripe" [elementsOptions]="stripeElementsOptions">
      <ngx-stripe-payment />
    </ngx-stripe-elements>
  </div>
  <div *ngIf="!paymentSucceeded" class="text-center mt-4 mb-5">
    <button type="button" class="btn btn-dark btn-lg w-75" [disabled]="inProgress"
      (click)="pay()">
      <span *ngIf="!inProgress" translate>BILLING.BTN_CONTINUE</span>
      <span *ngIf="inProgress" class="spinner-border" aria-hidden="true"></span>
    </button>
  </div>
  <div *ngIf="paymentSucceeded" class="mt-5 text-center">
    <p class="lead text-primary" translate>BILLING.DESC_PAYMENT_SUCCESSFUL</p>
    <button type="button" class="btn btn-dark btn-lg w-75" [disabled]="inProgress"
      (click)="finalizeReservation()">
      <span *ngIf="!inProgress" translate>BILLING.BTN_CONTINUE_2</span>
      <span *ngIf="inProgress" class="spinner-border" aria-hidden="true"></span>
    </button>
  </div>
</div>
